const lng = {
  material: {
    prop: 'جنس',
    cotton: 'کتان',
    denim: 'جین',
    ceramic: 'سرامیکی',
    heated: 'حرارتی',
    yarn: 'نخی ساده',
    'cotton-yarn': 'نخ پنبه',
    'crystal-cotton': 'پنبه کریستال',
    macan: 'ماکان',
  },
  designArea: {
    prop: 'ناحیه طراحی',
    front: 'جلو',
    back: 'پشت',
    both: 'هردو',
    wide: 'تمام نما',
  },
  color: {
    prop: 'رنگ',
    white: 'سفید',
    black: 'سیاه',
    '#aeafa5': 'زیتونی',
    '#8e7c61': 'خاکی',
    '#8f6664': 'پوست پیازی',
    '#baa89c': 'نسکافه ای', // mocha
    '#a0c6aa': 'سبز نعنایی', // mint-green
    '#bac5b2': 'سبز سدری', // sage-green
    '#808080': 'خاکستری', // gray
    '#d6d6d6': 'طوسی روشن', // light-gray
    '#635e5f': 'ماشی', // beige
  },
  size: {
    prop: 'سایز',
    S: 'اسمال',
    M: 'مدیوم',
    L: 'لارج',
    XL: 'ایکس لارج',
    '2XL': 'دو ایکس لارج',
    '330ml': '۳۳۰ میلی لیتر',

    shoulders: 'سرشانه',
    tallness: 'قد',
    collar: 'یقه',
    chest: 'عرض سینه',
    sleeves: 'طول آستین',
    height: 'ارتفاع',
    diameter: 'قطر',
  },
  ipg: {
    zarinpal: 'زرین پال',
  },
  tags: {
    men: 'مردانه',
    women: 'زنانه',
    hoodies: 'هودی',
    mug: 'ماگ',
    pixel: 'پیکسل',
    't-shirts': 'تیشرت',
    'phone-cases': 'قاب گوشی',
    socks: 'جوراب',
    dors: 'دورس',
  },
  seo: {
    hoodies: 'هودی',
    mug: 'ماگ',
    pixel: 'پیکسل',
    't-shirts': 'تیشرت',
    'phone-cases': 'قاب گوشی',
    socks: 'جوراب',
    dors: 'دورس',
  },
};

export default lng;
